import { OrderActionEnum } from 'desk-common';

const ACTION_MESSAGES: Record<OrderActionEnum, string> = {
  [OrderActionEnum.SAVE_DRAFT]: 'Pedido guardado correctamente',
  [OrderActionEnum.SEND]: 'Pedido enviado correctamente',
  [OrderActionEnum.CANCEL]: 'Pedido cancelado correctamente',
  [OrderActionEnum.DENY]: 'Pedido anulado correctamente',
  [OrderActionEnum.RETURNED]: 'Pedido devuelto correctamente',
  [OrderActionEnum.PREAPPROVE]: 'Pedido preaprobado correctamente',
  [OrderActionEnum.APPROVE]: 'Pedido aprobado correctamente',
  [OrderActionEnum.REJECT]: 'Pedido rechazado correctamente',
};

export const getSuccessMessage = (
  action: OrderActionEnum,
  isEdit: boolean
): string => {
  if (action === OrderActionEnum.SAVE_DRAFT && !isEdit) {
    return 'Pedido creado correctamente';
  }

  return ACTION_MESSAGES[action] ?? 'Operación realizada correctamente';
};
